import {
  Activity,
  Clock,
  Coins,
  Filter,
  Headset,
  Mail,
  PhoneCall,
  Receipt,
  ShieldCheck,
  Wallet,
  Shuffle,
  ThumbsDown,
  Trophy,
  type LucideIcon,
} from "lucide-react";

export type ReportDef = {
  key: string;
  path: string;
  titleKey: string;
  descriptionKey: string;
  icon: LucideIcon;
  enabled: boolean;
  /** Listed for admins only (the route and the RPC also refuse reps). */
  adminOnly?: boolean;
};

// Spec 09 §5. "emails" (Courriels) ships with batch 5, which flips `enabled` and adds its route.
export const REPORTS: readonly ReportDef[] = [
  {
    key: "funnel",
    path: "/rapports/entonnoir",
    titleKey: "gavion.reports.funnel.title",
    descriptionKey: "gavion.reports.index.funnel",
    icon: Filter,
    enabled: true,
  },
  {
    key: "activity",
    path: "/rapports/activite",
    titleKey: "gavion.reports.activity.title",
    descriptionKey: "gavion.reports.index.activity",
    icon: Activity,
    enabled: true,
  },
  // GAVION X1: Classement, readable by every active user
  {
    key: "ranking",
    path: "/rapports/classement",
    titleKey: "gavion.goals.leaderboard.title",
    descriptionKey: "gavion.goals.leaderboard.description",
    icon: Trophy,
    enabled: true,
  },
  // GAVION rep stats: acquisition cost, admins only
  {
    key: "costs",
    path: "/rapports/couts",
    titleKey: "gavion.costs.report.title",
    descriptionKey: "gavion.costs.report.description",
    icon: Wallet,
    enabled: true,
    adminOnly: true,
  },
  // GAVION team sessions: who is dialing now and every dial session, admins only
  {
    key: "sessions",
    path: "/rapports/sessions",
    titleKey: "gavion.sessions.title",
    descriptionKey: "gavion.sessions.description",
    icon: Headset,
    enabled: true,
    adminOnly: true,
  },
  // GAVION commissions: statements per person, preview, checks, per-client history (admins only)
  {
    key: "commissions",
    path: "/rapports/commissions",
    titleKey: "gavion.commissions_reports.title",
    descriptionKey: "gavion.commissions_reports.description",
    icon: Coins,
    enabled: true,
    adminOnly: true,
  },
  // GAVION commissions: the signed-in person's own statements, read only
  {
    key: "my_commissions",
    path: "/rapports/mes-commissions",
    titleKey: "gavion.commissions_reports.mine.title",
    descriptionKey: "gavion.commissions_reports.mine.description",
    icon: Receipt,
    enabled: true,
  },
  {
    key: "call_outcomes",
    path: "/rapports/resultats-appels",
    titleKey: "gavion.reports.call_outcomes.title",
    descriptionKey: "gavion.reports.index.call_outcomes",
    icon: PhoneCall,
    enabled: true,
  },
  // GAVION X5: best call hours, aggregates readable by every active user
  {
    key: "call_hours",
    path: "/rapports/heures-d-appel",
    titleKey: "gavion.call_hours.title",
    descriptionKey: "gavion.call_hours.description",
    icon: Clock,
    enabled: true,
  },
  {
    key: "emails",
    path: "/rapports/courriels",
    titleKey: "gavion.reports.index.emails_title",
    descriptionKey: "gavion.reports.index.emails",
    icon: Mail,
    enabled: false,
  },
  {
    key: "deal_sources",
    path: "/rapports/sources",
    titleKey: "gavion.reports.sources.title",
    descriptionKey: "gavion.reports.index.sources",
    icon: Shuffle,
    enabled: true,
  },
  {
    key: "loss_reasons",
    path: "/rapports/raisons-de-perte",
    titleKey: "gavion.reports.loss.title",
    descriptionKey: "gavion.reports.index.loss",
    icon: ThumbsDown,
    enabled: true,
  },
  {
    key: "data_quality",
    path: "/rapports/qualite-des-donnees",
    titleKey: "gavion.reports.quality.title",
    descriptionKey: "gavion.reports.index.quality",
    icon: ShieldCheck,
    enabled: true,
  },
];
